import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect, useCallback } from "react";
import { logoutUserWithoutToken } from "../../slices/session";
import { getCurrentUser } from "../../api/session";
import { useSelector } from "react-redux";
const AuthVerify = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const accessToken = useSelector((state) => state.session.accessToken);
  const loading = useSelector((state) => state.session.loading);

  const checkAccessToken = useCallback(async () => {
    try {
      const response = await getCurrentUser(accessToken);
      if (!response && !response?.data?.id) {
        dispatch(logoutUserWithoutToken());
      }
    } catch (err) {
      // dispatch(logoutUserWithoutToken());
      console.error("Error", err);
    }
  }, [accessToken, dispatch]);

  useEffect(() => {
    if (!loading) {
      checkAccessToken();
    }
  }, [location.pathname, loading, checkAccessToken]);
};

export default AuthVerify;
